import React from 'react';
import { Typography, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import UmleitungenHomeCard from './UmleitungenHomeCard';
import SchulungenHomeCard from './SchulungenHomeCard';
// import { Plans } from '../plans_screen/Plans';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import AdsterraAd from '../Ads/AdsterraAd';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import { PlansFire } from '../plans_screen/PlansFire';

export default function HomePage() {
  return (
    <>
     <PlansFire />
      {/* <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(320px, 450px))' }, // 1 column on mobile, 2 on desktop
          gap: 3,
          justifyContent: 'center', // center the columns
          px: { xs: 2, md: 4 },      // add horizontal padding to the whole grid
          py: { xs: 2, md: 4 },      // add vertical padding
          alignItems: 'stretch',
          gridAutoRows: { xs: 'auto', md: 'auto' } // allow each grid row to size to its tallest item;
          // that makes cards in the same row equal height, but different rows can differ
        }}
      > */}
       
        {/* <Card sx={{ height: 'auto', display: 'flex', flexDirection: 'column', p: { xs: 1.5, md: 3 } }}>
          <Box sx={{ width: '100%' }}>
            <Plans />
            
          </Box>
        </Card> */}

        {/* <Card sx={{ height: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', p: { xs: 1.5, md: 3 } }}>
          <Box sx={{ width: '100%' }}>
            <AdsterraAd />
          </Box>
        </Card> */}

        {/* <Card sx={{ height: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', p: { xs: 1.5, md: 3 } }}>
          <Box sx={{ width: '100%' }}>
            <UmleitungenHomeCard />
          </Box>
        </Card> */}

        {/* <Card sx={{ height: 'auto', display: 'flex', flexDirection: 'column', p: { xs: 1.5, md: 3 } }}>
          <Box sx={{ width: '100%' }}>
            
            <SchulungenHomeCard />
          </Box>
        </Card> */}

        {/* <Card sx={{ height: 'auto', display: 'flex', flexDirection: 'column', p: { xs: 1.5, md: 3 } }}>
          <Box sx={{ width: '100%' }}>
            <Paper elevation={3} sx={{ p: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
              <DirectionsBusIcon color="primary" sx={{ fontSize: 40 }} />
              <Box
                sx={{
                  flexGrow: 1,
                  cursor: 'pointer',
                  textDecoration: 'none',
                  color: 'inherit'
                }}
                component={RouterLink}
                to="/user_manuals/bus_stop_trainning"
              >
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  Bus Stop Training Game
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Interaktives Spiel zur richtigen Bus-Position am Haltestellenbereich.
                </Typography>
              </Box>
            </Paper>
          </Box>
        </Card> */}
      {/* </Box> */}
    </>
  );
}